import Layout from "../shared/Layout";
import CanvasPlate from "./CanvasPlate";
import ConversationToolbar from "./ConversationToolbar";
import { useParams } from "react-router-dom";
import useConversationCanvas from "./useConversationCanvas";
import "../../css/questions.css";

export default function ConversationCreatorCanvas() {
    const { id } = useParams();

    const {
        questions,
        edges,
        initialNodes,
        conversation,
        estimationGroups,
        stages,
        botErrors,
        reloadQuestions,
        reloadEstimationGroups,
        reloadConversation,
        saveCoordinates,
        createQuestion,
        updateConversation,
    } = useConversationCanvas(id);

    return (
        <Layout>
            <ConversationToolbar
                conversation={conversation}
                estimationGroups={estimationGroups}
                stages={stages}
                botErrors={botErrors}
                createQuestion={createQuestion}
                updateConversation={updateConversation}
                reloadEstimationGroups={reloadEstimationGroups}
                reloadConversation={reloadConversation}
            />

            {questions ? (
                <CanvasPlate
                    initialNodes={initialNodes}
                    edges={edges}
                    callbackSave={saveCoordinates}
                    estimationGroups={estimationGroups}
                    stages={stages}
                    botErrors={botErrors}
                    gotUpdatedQuestion={reloadQuestions}
                />
            ) : (
                ""
            )}
        </Layout>
    );
}
